import React from "react";
import Button from "../common/Button";
import styles from "./FieldMapDraftsCard.module.css";

export default function FieldMapDraftsCard({
  drafts,
  activeDraftId,
  onCreateNew,
  onOpen,
  onDelete,
  onRename,
  maxDrafts = 10,
}) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3>Meus FIELDMAPs</h3>

        <Button
          variant="primary"
          onClick={onCreateNew}
          disabled={drafts.length >= maxDrafts}
        >
          + Novo FIELDMAP
        </Button>
      </div>

      {drafts.length === 0 && (
        <p className={styles.empty}>Nenhum FIELDMAP criado ainda.</p>
      )}

      <ul className={styles.list}>
        {drafts.map((draft) => (
          <li
            key={draft.id}
            className={`${styles.item} ${
              draft.id === activeDraftId ? styles.active : ""
            }`}
          >
            <div className={styles.info}>
              <strong>{draft.title || "FIELDMAP sem título"}</strong>

              <span className={styles.meta}>
                Última edição:{" "}
                {draft.updatedAt?.toDate
                  ? draft.updatedAt.toDate().toLocaleDateString()
                  : "—"}
              </span>
            </div>

            <div className={styles.actions}>
              {draft.id !== activeDraftId && (
                <Button variant="outline" onClick={() => onOpen(draft)}>
                  Abrir
                </Button>
              )}

              <Button
                variant="outline"
                onClick={() => {
                  const newTitle = prompt("Renomear FIELDMAP:", draft.title);
                  if (newTitle && newTitle.trim()) {
                    onRename(draft.id, newTitle.trim());
                  }
                }}
              >
                Renomear
              </Button>

              <Button
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm(
                      "Tem certeza que deseja excluir este FIELDMAP?"
                    )
                  ) {
                    onDelete(draft.id);
                  }
                }}
              >
                Excluir
              </Button>
            </div>
          </li>
        ))}
      </ul>

      {drafts.length >= maxDrafts && (
        <p className={styles.limit}>
          Limite de {maxDrafts} FIELDMAPs atingido. Exclua um para criar outro.
        </p>
      )}
    </div>
  );
}
